var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.payload.attribute.data),function(value,key){return _c('div',{key:key,attrs:{"dir":"rtl"}},[_c('p',[_c('b',[_vm._v(_vm._s(key)+": ")]),_vm._v(_vm._s(value)+"\n      ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }